import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-mail-config-setting',
  templateUrl: './mail-config-setting.component.html',
  styleUrls: ['./mail-config-setting.component.css']
})
export class MailConfigSettingComponent implements OnInit {

  public isEdit: boolean = false;
  public subjectID: any;
  public formSubmitted: boolean = false;
  public formObject: any = {
    type: '',
    prefix: '',
    suffix: '',
    defaultSubject: 'Staff Commute Solution',
    customSubject: '',
    mailSubject: '',
  }
  public errorObject: any = {};
  public mailConfigData: any = {};

  constructor(private api: ApiService, private swal: SweetAlert) { }


  ngOnInit(): void {
    this.getMailConfigData()
  }

  getMailConfigData() {
    this.api.transportManagerGblSetMailConfigList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if(res.data && res.data[0]){
          this.isEdit = true;
          this.patchValue(res.data[0])
        }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  patchValue(obj) {
    this.formObject['type'] = obj.subjectType ? obj.subjectType : '';
    this.formObject['customSubject'] = obj.customSubject ? obj.customSubject : '';
    this.formObject['mailSubject'] = obj.mailSubject ? obj.mailSubject : '';
    this.subjectID = obj['subjectID'];
    if (obj['subjectType']) {
      this.formObject[obj['subjectType']] = obj.customSubject ? obj.customSubject : '';
    }
  }


  fieldChange(field, event) {
    
    let value = String(event.target.value).trim();
    if (field == 'prefix' || field == 'suffix') {
      if (value != '') {
        this.formObject.type = field;
        this.formObject.customSubject = value;
        this.formObject[field] = value;
        if (field == 'prefix') {
          this.formObject.suffix = '';
          this.formObject.mailSubject = value + ' - ' + this.formObject.defaultSubject;
        } else if (field == 'suffix') {
          this.formObject.prefix = '';
          this.formObject.mailSubject = this.formObject.defaultSubject + ' - ' + value;
        }
      }
      else {
        this.formObject.type = '';
        this.formObject[field] = '';
        this.formObject.customSubject = '';
        this.formObject.mailSubject = '';
      }
    }

    if (this.formSubmitted) this.validation();
  }

  validation() {
    let isValid = true;
    this.errorObject = {};
    if (this.formObject.customSubject == '') {
      this.errorObject['customSubject'] = 'Subject is required!'
      isValid = false;
    }
    return isValid;
  }

  onSubmit() {
    this.formSubmitted = true;
    console.log(this.formObject)
    let isValid = this.validation();
    if (isValid) {
      let obj = {
        subjectType: this.formObject.type,
        customSubject: this.formObject.customSubject,
        mailSubject: this.formObject.mailSubject
      };
      let apiMethod = "transportManagerGblSetMailConfigCreate";
      if (this.isEdit) {
        apiMethod = "transportManagerGblSetMailConfigUpdate";
        obj['subjectID'] = this.subjectID;
      }
      this.api[apiMethod](obj).then((res) => {
        console.log(res);

        if (res.status == 'success') {
          this.getMailConfigData();
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }

      }).catch((err) => {
        console.log('error', err);
      })
      console.log('finalObj', obj);
    }
  }

}